import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil, tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { EmployerService } from '../../../employer/services/employer.service';
import { S3ServiceService } from '../../../../s3-service.service';
import {
  CommonFunctionsService, NgxToasterService, UserService
} from '../../../../_services/index';
import { interval } from 'rxjs';
import { Router } from "@angular/router";

@Component({
  selector: 'file-uploadcover',
  templateUrl: "file-uploadcover.component.html",
  styleUrls: ["file-uploadcover.component.css"],
  providers: [EmployerService]
})
export class FileUploadcoverComponent implements OnInit {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  env = environment;
  @Input() requiredFileType: string = '';


  fileName = '';
  uploadProgress: number = 0;
  responseData: string = '';

  texts = [
    'Generate a standout resume in seconds with our AI-powered tool.',
    'Create engaging content for your job applications with AI assistance.',
    'Easily upload and fetch your existing resumes from cloud storage.',
    'Optimize your resume with AI insights for better job matches.',
    'Transform your ideas into polished text with our AI writing tool.'
  ];
  visibleIndex = -1;
  displayedIndices: Set<number> = new Set();

  constructor(
    private http: HttpClient,
    private employerService: EmployerService,
    public router: Router,
    private s3Service: S3ServiceService,
    public commonFunctionsService: CommonFunctionsService,
    private toasterNotification: NgxToasterService,
    private userService: UserService
  ) {}

  ngOnInit() {
    // Show a random text every 2 seconds
    interval(4000).subscribe(() => {
      this.selectRandomText();
    });
  }



  selectRandomText() {
    if (this.displayedIndices.size === this.texts.length) {
      // Reset if all texts have been displayed
      this.displayedIndices.clear();
    }

    let randomIndex: number;
    do {
      randomIndex = Math.floor(Math.random() * this.texts.length);
    } while (this.displayedIndices.has(randomIndex));

    this.displayedIndices.add(randomIndex);
    this.visibleIndex = randomIndex;
  }

  async onFileSelected(event: any) {


    const file: File = event.target.files[0];

    if (file) {
      this.uploadProgress = 25;
      try {
        let resume = await this.s3Service.uploadFile(file);
        let formData = { user_id: this.userService.getCurrentUser()._id };

        this.uploadProgress = 90;
        console.log(resume, 'Uploaded resume!');
        this.commonFunctionsService
          .submitcoverletter({ ...formData, resume: resume })
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((response: any) => {
            if (response.status === this.env.SUCCESS_STATUS) {
              this.toasterNotification.showSuccess(response.message);
            } else {
              this.toasterNotification.showError(response.message);
            }
            this.uploadProgress = 0;
             this.router.navigate(['jobseeker/cover_letter']);   
            // window.location.reload();
          });
      } catch (e) {
        console.log(e, 'Upload error');
      }
    }
  }

  public getParseResume() {
    let formData = { file: 'file' };

    this.employerService.getParseResume(formData).pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
      if (response.status === this.env.SUCCESS_STATUS) {
        this.responseData = JSON.stringify(response.result);
      }
    });
  }

  cancelUpload() {
    this.reset();
  }

  reset() {
    this.uploadProgress = 0;
  }
}
